import Expandable from "../../generic-building-blocks/Expandable";
import SubscriberNotificationFilters from "../editFormReboot/SubscriberNotificationFilters";
import { NotificationFilterType, NotificationType } from "@prisma/client";
import _ from "lodash";
import React from "react";

interface Props {
  notificationPrefix: string;
  supportedTypes: NotificationFilterType[];
  notificationType: NotificationType;
}

export default function CustomNotifications({ notificationPrefix, supportedTypes, notificationType }: Props): JSX.Element {
  return (
    <Expandable
      title={<span className="font-semibold text-sm">Customize Notifications</span>}
      tooltipText={`Configure what notifications your subscriber should receive.`}
    >
      <div className="border border-1 p-5">
        <label className="block text-sm font-medium leading-5 text-gray-700 mb-1">Notification Preferences</label>
        <SubscriberNotificationFilters name={`${notificationPrefix}.notificationFilters`} supportedTypes={supportedTypes} notificationType={notificationType} />
      </div>
    </Expandable>
  );
}
